export default ({ thematic, index }) => `${thematic}-${index || 0}`;
